import script from "./ExchangeTicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExchangeTicker.vue?vue&type=script&setup=true&lang=ts"

import "./ExchangeTicker.vue?vue&type=style&index=0&id=5d25d661&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d25d661"]])

export default __exports__